import {Utils} from '@astek/utils';
import {JsonConfigInterface} from './json-config-interface';

export type NumberIntervalConfigJson =  {
  min: number;
  max: number;
};

export class NumberIntervalConfig implements JsonConfigInterface<NumberIntervalConfigJson> {

  private _min: number = 0;
  private _max: number = 0;

  constructor(json?: NumberIntervalConfigJson) {
    if (!Utils.isNullOrUndefined(json)) {
      this.deserializeJson(json);
    }
  }

  public get min(): number {
    return this._min;
  }

  public get max(): number {
    return this._max;
  }

  public deserializeJson(json: NumberIntervalConfigJson): void {
    this._min = json.min;
    this._max = json.max;
  }
}
